import React from 'react'
import { Dialog } from "primereact/dialog";

const PreviewModal = (props) => {
    return <Dialog header={"Vista Previa"} visible={props.imageURL} onHide={() => props.closePreviewModal()} >
    <img className="" height={600} style={{ maxWidth: '100%' }} src={props.imageURL} />
</Dialog >
}
export default PreviewModal;
